export default "/packs/images/expeditions-banner~bf82c6e8a0cd37179b0392b118e84b4d.jpg";